import React from 'react';
import templateData from '../utility/getTemplateData';
import { StyleSheet, css } from 'aphrodite';

const styles = StyleSheet.create({
  centedImage: {
    maxWidth: 300,
    maxHeight: 120,
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: 20,
  },
});

class CharityLogo extends React.Component {
  constructor() {
    super();
    const logoUrl = templateData.logoUrl || '';
    this.state = {
      bannerUrl: logoUrl.includes('https') ? logoUrl : false,
      altText: templateData.donationName || '',
    };
  }

  render() {
    return (
      <div className="ppvx_row donate_banner_wrapper">
        <div className="ppvx_col-sm-12">
          <div className="banner_img_holder center-block">
            {this.state.bannerUrl ? (
              <img
                alt={this.state.altText}
                id="charityLogo"
                className={css(styles.centedImage)}
                src={this.state.bannerUrl}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default CharityLogo;
